import React from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import PdfGenerateLink from "src/components/PdfGenerateLink";

export default function InternalWorkOrderSuccess({
  internalWorkOrder,
  projectId,
  displaySuccessAction,
  onClose,
}) {
  return (
    <>
      <DialogContent>
        <DialogContentText>
          <Box pt={2}>
            <Typography align="center">
              Your internal order has been submitted successfully.
            </Typography>
            {internalWorkOrder && (
              <Box pt={4} display="flex" justifyContent="center">
                <PdfGenerateLink
                  resourceType="internal_work_order_pdfs"
                  resourceId={internalWorkOrder?.id}
                  sx={{ textDecoration: "underline", fontWeight: 500, fontSize: 16 }}
                  label={`${internalWorkOrder.internalWorkOrderNumber} PDF Receipt`}
                />
              </Box>
            )}
          </Box>
        </DialogContentText>
      </DialogContent>
    </>
  );
}
